
import React, { Suspense, useState, useEffect } from "react";
import systemListingService from "./SystemListingServices";
import AnalysisCodesDrawer from "../../AssetLinking/MenuDrawer";
import Pagination from "components/Common/newPagination";
import AnalysisCodeUpsert from "./upsert/AnalysisCodeUpsert";

export default function AnalysisCodesPage(param: any) {
  let [searchFor, setsearchFor] = useState("");
  let [editDawer, setEditDawer] = useState<any>(false);
  const [showDims, setShowDims] = useState<boolean>(false);
  const [editingOn, setEditingOn] = useState<boolean>(false);
  const [editDataDawer, setEditDataDawer] = useState<any>([]);
  const [analsisCodeListing, SetAnalsisCodeListing] = useState<any>([]);
  const [activeCategory, setActiveCategory] = useState<Category>("Recorded Music");
  let [analsisCodeCount, setAnalsisCodeCount] = useState<number>(0);

  console.log(param)

  useEffect(() => {
    searchFor = '';
    setsearchFor(searchFor);
    if (param.activeTab === "Analysis codes") {
      analysisTypeSelect("Recorded Music")
    }
  }, [param])


  type Category = "Recorded Music" | "Mechanical" | "Publishing" | "Costs" | "Advances" | "Licensing";
  const categories: Category[] = ["Recorded Music", "Mechanical", "Publishing", "Costs", "Advances", "Licensing",];

  const openAddDrawer = (code: any) => {
    if (code) {
      setEditDataDawer(code)
    }
    editDawer = true
    setEditDawer(editDawer);
    console.log(editDawer)

  };

  const analysisTypeSelect = (analysisType: any) => {
    console.log(analysisType)
    setActiveCategory(analysisType);

    analsisCodeCount = 0;
    setAnalsisCodeCount(analsisCodeCount)

    var payload = {
      pageNumber: 1,
      pageSize: 10,
      searchFor: searchFor
    }

    if (analysisType === "Recorded Music") {
      systemListingService.getSalesAnalysissales(payload).then(respond => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Mechanical") {
      systemListingService.getSalesAnalysismechanical(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }


    if (analysisType === "Publishing") {
      systemListingService.getSalesAnalysispublishing(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Costs") {
      systemListingService.getSalesAnalysiscosts(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Advances") {
      systemListingService.getSalesAnalysisadvances(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }

    if (analysisType === "Licensing") {
      systemListingService.getSalesAnalysislicensing(payload).then((respond: any) => {
        SetAnalsisCodeListing(respond)
        analsisCodeCount = respond && respond[0].totalRows ? respond[0].totalRows : 0
        setAnalsisCodeCount(analsisCodeCount);
      })
    }


  }
  const onPageChange = (e: any) => {
    console.log(e)
  }
  const closeDrawer = () => {
    editDawer = false
    setEditDawer(editDawer);
    console.log(editDawer)
  }

  const sliderChange = (typeFor: any, e: any) => {
    console.log(e)
    if (typeFor == "Mechanicals") {
      if (e?.mechanicalBearing == 1) {
        e.mechanicalBearing = 0;
      }

      if (e?.mechanicalBearing == 0) {
        e.mechanicalBearing = 1;
      }
    }

    if (typeFor == "Default") {
      if (e?.isDefault == 1) {
        e.isDefault = 0;
      }

      if (e?.isDefault == 0) {
        e.isDefault = 1;
      }
    }

    console.log(e)

  }


  const dropDownChange = (type: any, e: any, object_upsert: any) => {
    console.log(object_upsert)
    console.log(type)
    console.log(e)

    if (type == "Type") {

      if (e == "sales") {
        object_upsert.salesCode = 1;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 0;
      }

      if (e == "flatFee") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 1;
        object_upsert.publCode = 0;
      }

      if (e == "publishingInc") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 1;
      }

      if (e == "costs") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 1;
        object_upsert.advanceCode = 0;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 0;
      }

      if (e == "advances") {
        object_upsert.salesCode = 0;
        object_upsert.costsCode = 0;
        object_upsert.advanceCode = 1;
        object_upsert.flatFeeCode = 0;
        object_upsert.publCode = 0;
      }
    }

    if (type == "PointProfit") {

      if (e == "both") {
        object_upsert.useInPoints = 1;
        object_upsert.useInProfit = 1;
      }

      if (e == "pointsOnly") {
        object_upsert.useInPoints = 1;
        object_upsert.useInProfit = 0;
      }

      if (e == "profitOnly") {
        object_upsert.useInPoints = 0;
        object_upsert.useInProfit = 1;
      }

      if (e == "neither") {
        object_upsert.useInPoints = 0;
        object_upsert.useInProfit = 0;
      }
    }

    console.log(object_upsert)
  }

  return (
    <>
      <div className="content-card ws-12">

        <div className="card-header-row ws-12">
          <div className="card-title">Analysis Codes</div>
          <div className="card-header-actions">
            <span className="pt mt">
              {analsisCodeCount} record(s) found
            </span>
            <button className="icon-btn info" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}   >
              {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
            </button>
          </div>
        </div>

        <div className="filter-row ws-12 pm" style={{ borderRadius: 8, border: "1px solid #e5e7eb" }}  >
          <div className="filter-input-row" style={{ alignItems: "flex-end" }}>
            <div className="filter-inline">
              <div className="filter-label">Filter</div>
              <div className="filter-input-group">
                <input className="form-input" placeholder="By code, description or group" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} style={{ minWidth: 420 }} />
                <button className="icon-btn primary" type="button" onClick={() => analysisTypeSelect(activeCategory)}  >
                  Search
                </button>
              </div>
            </div>

            {/* DIM Columns toggle */}
            <div className="filter-inline" style={{ alignItems: "flex-end", marginLeft: "auto" }} >
              <div className="filter-label">DIM Columns</div>
              <div className="ac-toggle">
                <span style={{ fontSize: 13, color: "#374151" }}> {showDims ? "Shown" : "Hidden"} </span>
                <div className={"pp-switch" + (showDims ? " on" : "")} onClick={() => setShowDims((prev) => !prev)} role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setShowDims((p) => !p);
                  }}
                  style={{ cursor: "pointer" }}
                  aria-pressed={showDims}
                  title="Toggle DIM columns"
                >
                  <div className="pp-knob" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="category-tabs-row ws-12">
          <div className="category-tabs">
            {categories.map((cat) => (
              <button key={cat} className={"category-tab" + (cat === activeCategory ? " active" : "")} onClick={() => { setActiveCategory(cat); analysisTypeSelect(cat) }}  >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="table-wrapper ws-12">
          <div className="table-scroll">
            {analsisCodeListing.length > 0 && <>

              <table className={editingOn ? "editing-on newTable" : " newTable"} >
                <thead>
                  <tr>
                    {showDims ? (
                      <>
                        <th >Code</th>
                        <th className="col-dim">DIM 1 Db</th>
                        <th className="col-dim">DIM 2 Cr</th>
                        <th className="col-dim">DIM 3 Db</th>
                        <th className="col-dim">DIM 4 Cr</th>
                        <th >Operations</th>
                      </>
                    ) : (
                      <>
                        <th >Code</th>
                        <th >Description</th>
                        <th >Group</th>
                        <th >Points / Profits</th>
                        <th >Type</th>
                        <th >Mechanicals</th>
                        <th style={{ width: "19%" }}>Operations</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {analsisCodeListing.map((AnalysisRow: any) => (
                    <tr key={AnalysisRow.code} className={AnalysisRow.isDefault ? "default-row" : ""} >
                      {showDims ? (
                        <>
                          <td >{AnalysisRow.analysisCode}</td>
                          <td className="col-dim">{AnalysisRow.analysisDIM1}</td>
                          <td className="col-dim">{AnalysisRow.analysisDIM2}</td>
                          <td className="col-dim">{AnalysisRow.analysisDIM3}</td>
                          <td className="col-dim">{AnalysisRow.analysisDIM4}</td>
                          <td className="forceSingleLine" style={{ width: "15%", padding: "12px 8px" }}>
                            <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}  >
                              <button className={"btn-default" + (AnalysisRow.isDefault === 1 ? " active" : "")} type="button" disabled={!editingOn}  >
                                Default
                              </button>

                              <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} onClick={() => openAddDrawer(AnalysisRow)}>
                                <i className="icon-pencil"> </i>
                              </button>

                              <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn}  >
                                <i className="icon-trash"> </i>
                              </button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <>
                          <td >{AnalysisRow.analysisCode}</td>
                          <td >{AnalysisRow.analysisText}</td>
                          <td >{AnalysisRow.analysisSort}</td>
                          <td >
                            <div className="cell-with-select">
                              <select disabled={!editingOn} onChange={(e: any) => dropDownChange('PointProfit', e.target.value, AnalysisRow)}>
                                <option value="both">Both</option>
                                <option value="pointsOnly">Points Only</option>
                                <option value="profitOnly">Profit Only</option>
                                <option value="neither">Neither</option>
                              </select>
                            </div>
                          </td>
                          <td >

                            <div className="cell-with-select">
                              <select disabled={!editingOn} onChange={(e: any) => dropDownChange('Type', e.target.value, AnalysisRow)}>
                                <option value="sales">Sales</option>
                                <option value="flatFee">Flat Fee</option>
                                <option value="publishingInc">Publishing</option>
                                <option value="costs">Costs</option>
                                <option value="advances">Advances</option>
                              </select>
                            </div>
                          </td>

                          <td >
                            <div className="points-profits">
                              <div className={"pp-switch" + (AnalysisRow?.mechanicalBearing === 1 ? " on" : "") + (!editingOn ? " disabled" : "")}
                                style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}
                                onClick={() => sliderChange("Mechanicals", AnalysisRow)}>
                                <div className="pp-knob" />
                              </div>
                            </div>
                          </td>

                          <td className="forceSingleLine" style={{ width: "15%" }}  >
                            <div style={{ opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}  >
                              <button className={"btn-default" + (AnalysisRow.isDefault ? " active" : "")} type="button" disabled={!editingOn}
                                onClick={() => sliderChange("Default", AnalysisRow)}>
                                Default
                              </button>

                              <button className="icon-btn edit" title="Edit " type="button" disabled={!editingOn} onClick={() => openAddDrawer(AnalysisRow)}>
                                <i className="icon-pencil"></i>
                              </button>

                              <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn}  >
                                <i className="icon-trash"> </i>
                              </button>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>

              {analsisCodeListing.length > 10 && <>
                <Pagination totalRow={analsisCodeListing.length} onPageChange={onPageChange} />
              </>}
            </>}

            {analsisCodeListing.length === 0 && <div className="ws-12">
              <div className="alert alert-info ws-12 box" >No records to display</div>
            </div>}
          </div>
        </div>

        <div className="add-row-wrapper ws-12">
          <button className="btn-add-row" type="button" disabled={!editingOn} onClick={openAddDrawer} >
            + Add Analysis Code
          </button>
        </div>

      </div>

      {(() => {

        if (editDawer === true) {

          return <AnalysisCodeUpsert editDawer={editDawer} editDataDawer={editDataDawer} closeDrawer={closeDrawer} activeCategory={activeCategory} />
        }

      })()}
    </>
  );
}; 